import * as actionTypes from './actionsTypes';

export const setLoadParcelDimensions = (parcelDetails) => {

  return {
    type: actionTypes.SETLOADPARCELDIMENSIONS,
    data: parcelDetails,
  };
};
